import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Loader2, ArrowUpRight } from "lucide-react";
import { api } from "../../lib/api";
import { MODULES } from "./modulesConfig";

export default function ModuleSearch() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 2) { setResults([]); setSearched(false); return; }
    timer.current = setTimeout(() => {
      setLoading(true);
      api.get(`/mod/search`, { params: { q } })
        .then((r) => { setResults(r.data.results || []); setTotal(r.data.total || 0); setSearched(true); })
        .catch(() => {})
        .finally(() => setLoading(false));
    }, 350);
    return () => clearTimeout(timer.current);
  }, [q]);

  return (
    <div className="card-surface p-5 space-y-4" data-testid="module-search">
      <div className="relative">
        <Search className="w-4 h-4 text-navy/40 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Busca en todas tus apps: proyectos, documentos, reuniones, aprobaciones…"
          className="w-full bg-white border border-navy/10 rounded-lg pl-10 pr-3 py-2.5 outline-none focus:border-violet text-sm"
          data-testid="search-input"
        />
        {loading && <Loader2 className="w-4 h-4 animate-spin text-navy/40 absolute right-3 top-1/2 -translate-y-1/2" />}
      </div>

      {searched && (
        <div className="text-xs text-navy/40" data-testid="search-count">
          {total} resultado{total === 1 ? "" : "s"} en {new Set(results.map((r) => r.module_key)).size} app(s)
        </div>
      )}

      <div className="space-y-2">
        {results.map((r) => {
          const cfg = MODULES[r.module_key];
          return (
            <Link
              key={`${r.module_key}-${r.id}`}
              to={`/os/mod/${r.module_key}`}
              className="flex items-center justify-between gap-3 border border-navy/10 rounded-lg px-3 py-2.5 hover:border-violet hover:bg-navy/[0.02] transition-colors"
              data-testid={`search-result-${r.id}`}
            >
              <div className="min-w-0">
                <div className="text-sm text-navy/85 truncate">{r.label}</div>
                <div className="text-[11px] text-navy/40 truncate">{cfg?.title || r.module_key}</div>
              </div>
              <ArrowUpRight className="w-4 h-4 text-navy/30 shrink-0" />
            </Link>
          );
        })}
        {searched && !loading && results.length === 0 && (
          <div className="text-center text-navy/40 text-sm py-6" data-testid="search-empty">Sin coincidencias para “{q}”.</div>
        )}
      </div>
    </div>
  );
}
